// #35249: helpers for the matching-active-policy "purchase anyway?" warning. Kept in their own
// module (no store imports) so they can be unit-tested without pulling in the whole offer store,
// which has a circular dependency with store.mobx at import time.

// Marker the pre-bind step appends (ERROR_CODE: MATCHING_ACTIVE_POLICY) when a bind matches an
// active policy for the same insured + primary property. Non-numeric, so it never looks like a
// billing decline; staff-fe keys the confirmation on it.
export const MatchingActivePolicyErrorCode = 'MATCHING_ACTIVE_POLICY';

// Pull the matching policy ids out of the internal warning message
// ("...matches active policy A, B for this member..."). External-user messages carry no ids and
// yield an empty list, which the confirmation copes with.
export const parseMatchingActivePolicyIds = (message) => {
  if (typeof message !== 'string') {
    return [];
  }
  const match = message.match(/active polic(?:y|ies)\s+(.+?)\s+for this member/i);
  if (!match) {
    return [];
  }
  return match[1]
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);
};
